import React from "react";
import styles from "./LayoutRoot.scss";

export const LayoutRoot = ({ children }) => {
    return <div className={styles.layout}>{children}</div>;
};
